function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.WarningAlertFill", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["WarningAlertFill"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var WarningAlertFill = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.60161 20.5001C2.44611 20.5001 1.72452 19.2486 2.30347 18.2486L10.7018 3.74234C11.2795 2.74442 12.7203 2.74441 13.2981 3.74234L21.6964 18.2485C22.2754 19.2485 21.5538 20.5001 20.3983 20.5001H3.60161ZM10.9999 10.0001V13.0001C10.9999 13.5524 11.4477 14.0001 11.9999 14.0001C12.5522 14.0001 12.9999 13.5524 12.9999 13.0001V10.0001C12.9999 9.44782 12.5522 9.0001 11.9999 9.0001C11.4477 9.0001 10.9999 9.44782 10.9999 10.0001ZM10.9999 16.5001C10.9999 17.0524 11.4477 17.5001 11.9999 17.5001C12.5522 17.5001 12.9999 17.0524 12.9999 16.5001C12.9999 15.9478 12.5522 15.5001 11.9999 15.5001C11.4477 15.5001 10.9999 15.9478 10.9999 16.5001Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = WarningAlertFill;
});